var Phase;
(function (Phase) {
    Phase[Phase["MINI_MARCO"] = 1] = "MINI_MARCO";
    Phase[Phase["MAXI_MARCO"] = 2] = "MAXI_MARCO";
})(Phase || (Phase = {}));
export default Phase;
